import { createContext } from "react";
import { DefaultPlayer, Player } from "./utils/Player";

interface UserContextInterface {
    user: Player,
    setUser: (newUser: Player) => void
}

export const sampleUserContext: UserContextInterface = {
    user: DefaultPlayer,
    setUser: (newUser: Player) => { }
}

const UserContext = createContext<UserContextInterface>(sampleUserContext);
export default UserContext;